import { render } from "./sign-up.vue?vue&type=template&id=a09b425e"
import script from "./sign-up.vue?vue&type=script&lang=js"
export * from "./sign-up.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__